import { faXmark } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Streak } from '@tryhackme/thm-ui-components';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppSelector } from 'src/app/hooks';
import { useRepairStreak } from 'src/common/hooks/use-repair-streak';
import type { UserData } from 'src/common/interfaces';
import { AccessNetworks } from '../../../access-networks';
import { StyledAccessMachine, StyledSideSectionCloseBtn, StyledTopBar } from './room-banner-top-bar.styles';
export const RoomBannerTopBar = ({
  userData,
  splitScreenOpen
}: {
  userData?: UserData;
  splitScreenOpen: boolean;
}) => {
  const [isSlidingPaneOpen, setIsSlidingPaneOpen] = useState<boolean>(false);
  const repairStreakHandler = useRepairStreak();
  const navigate = useNavigate();
  const remAttackBoxBtn = useAppSelector(state => state.room.remAttackBoxBtn);
  const hasUserJoinedRoom = useAppSelector(state => state.room.hasUserJoinedRoom);
  const attackBoxPrivateIP = useAppSelector(state => state.splitScreen.attackBoxPrivateIP);
  const showAccessMachinesButton = !!userData?.user && hasUserJoinedRoom && !remAttackBoxBtn && !splitScreenOpen;
  const streak = userData?.user.streak;
  return <StyledTopBar data-sentry-element="StyledTopBar" data-sentry-component="RoomBannerTopBar" data-sentry-source-file="room-banner-top-bar.tsx">
      {showAccessMachinesButton && <StyledAccessMachine connected={!!attackBoxPrivateIP} type="button" onClick={() => setIsSlidingPaneOpen(true)}>
          {attackBoxPrivateIP ?? 'Access Machines'}
        </StyledAccessMachine>}
      {streak && <Streak {...streak} onStreakRepair={repairStreakHandler} />}
      <StyledSideSectionCloseBtn onClick={() => navigate('/hacktivities')} aria-label="close" data-sentry-element="StyledSideSectionCloseBtn" data-sentry-source-file="room-banner-top-bar.tsx">
        <FontAwesomeIcon icon={faXmark} data-sentry-element="FontAwesomeIcon" data-sentry-source-file="room-banner-top-bar.tsx" />
      </StyledSideSectionCloseBtn>
      {isSlidingPaneOpen && <AccessNetworks isSlidingPaneOpen setIsSlidingPaneOpen={setIsSlidingPaneOpen} machineIP={attackBoxPrivateIP} />}
    </StyledTopBar>;
};